import { render, staticRenderFns } from "./ProofOfDelivery.vue?vue&type=template&id=08de2828&"
import script from "./ProofOfDelivery.vue?vue&type=script&lang=js&"
export * from "./ProofOfDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports